import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../-LazyRoutePage"

const CriticalStockReportsPage = lazy(
  () =>
    import("../../../../components/WMS/Warehouses/CriticalStockReportsPage"),
)

export const Route = createFileRoute(
  "/_layout/WMS/warehouses/critical-stock-reports",
)({
  component: CriticalStockReportsRoute,
})

function CriticalStockReportsRoute() {
  return (
    <LazyRoutePage>
      <CriticalStockReportsPage />
    </LazyRoutePage>
  )
}
